import * as React from 'react';
import {Card, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from "@mui/material/IconButton";
import {MoreVertOutlined, ShoppingCartOutlined} from '@mui/icons-material';
import {PiePlot, ChartContainer} from "@mui/x-charts";
import {XYVO} from "@/service/analyze";
import {sumBy} from "lodash";
import {ChartsLoadingOverlay} from "@mui/x-charts/ChartsOverlay";

export interface CopyrightCardProps {
    copyrights?: XYVO[];
    loading: boolean;
}

export default function CopyrightCard({copyrights, loading}: CopyrightCardProps) {
    return (
        <Card variant="outlined" sx={{height: '100%', flexGrow: 1, backgroundColor: '#fff2ca'}}>
            <CardContent sx={{height: '100%'}}>
                <Stack justifyContent={'space-between'} height={'inherit'}>
                    <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                        <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                            <IconButton sx={{bgcolor: '#f3ae22', padding: '4px 12px', borderRadius: '99999px'}}>
                                <ShoppingCartOutlined sx={{color: '#fff'}}/>
                            </IconButton>
                            <Typography fontWeight={500} component="h1" color={'#7b8893'} variant='body1'>
                                版权
                            </Typography>
                        </Stack>
                        <MoreVertOutlined color={'action'}/>
                    </Stack>
                    <Grid container rowSpacing={6} alignItems={'end'}>
                        <Grid size={7}>
                            <Chip label={<Typography fontSize={'12px'} color={'textSecondary'}>全部</Typography>}/>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={20} fontWeight={550}>{sumBy(copyrights, item => item.y) || 0}个</Typography>
                        </Grid>
                        <Grid size={5}>
                            <ChartContainer
                                height={120}
                                localeText={{loading: loading ? "加载中" : ''}}
                                yAxis={[{position: 'none'}]}
                                margin={{left: 0, right: 0, top: 0, bottom: 0}}
                                series={[{
                                    data: [
                                        {label: 'Group A', value: 260, color: '#ff6692'},
                                        {label: 'Group B', value: 300, color: '#ffae1f'},
                                        {label: 'Group C', value: 180, color: '#00a1ff'},
                                        {label: 'Group D', value: 200, color: '#00ceb6'},
                                    ], type: 'pie', startAngle: -90, cy: 104,
                                    endAngle: 90,
                                    innerRadius: 34,
                                    paddingAngle: 3,
                                },]}
                            >
                                <ChartsLoadingOverlay/>
                                <PiePlot/>
                            </ChartContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    );
}
